var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.83997C10.21 8.83997 12 7.04997 12 4.83997C12 2.62997 10.21 0.839966 8 0.839966C5.79 0.839966 4 2.62997 4 4.83997C4 7.04997 5.79 8.83997 8 8.83997ZM8 10.84C5.33 10.84 0 12.18 0 14.84V16.84H16V14.84C16 12.18 10.67 10.84 8 10.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid14);
export default __webpack_public_path__ + "static/media/grid14.0a18d5d504deb6316f4ce54a2f4931b3.svg";
export { ForwardRef as ReactComponent };